<template>
  <div class="sb-nav-fixed">
    <!-- Navbar pour mobile (visible uniquement en dessous du breakpoint lg) -->
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark d-lg-none">
      <div class="container-fluid">
        <!-- Logo renvoyant vers Accueil -->
        <router-link class="navbar-brand" to="/home">
          <img src="/assets/logoMirindra.PNG" alt="logo" class="img-fluid" style="max-width: 120px;" />
        </router-link>
        <!-- Bouton hamburger -->
        <button 
          class="navbar-toggler" 
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#mobileMenu" 
          aria-controls="mobileMenu" 
          aria-expanded="false" 
          aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <!-- Menu mobile simplifié -->
        <div class="collapse navbar-collapse" id="mobileMenu">
          <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
            <li class="nav-item">
              <router-link class="nav-link" to="/home">Accueil</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/add-location">Liste reservation </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/articles">Articles</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/admin-page">Administrateur</router-link>
            </li>
            <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapseLayouts" aria-expanded="false" aria-controls="collapseLayouts">
                <div class="sb-nav-link-icon"><i class="fas fa-columns"></i></div>
                    Gestion d'accès
                <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
              </a>
                <!-- <div class="collapse" id="collapseLayouts" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion"> -->
                <nav class="sb-sidenav-menu-nested nav">
                  <router-link to="/permission-page" class="nav-link">Rôles</router-link>
                      <router-link to="/mon_compte" class="nav-link">Mon compte</router-link>
                      <router-link to="/liste_utlisateur" class="nav-link">Listes des utilisateurs</router-link>
                </nav>
          </ul>
        </div>
      </div>
    </nav>

    <!-- Navbar pour desktop (visible uniquement au-delà du breakpoint lg) -->
    <nav class="sb-topnav navbar navbar-expand navbar-dark bg-dark d-none d-lg-flex">
      <!-- Logo -->
      <div class="navbar-brand ps-3">
        <img src="/assets/logoMirindra.PNG" alt="logo" class="img-fluid" style="max-width: 120px;" />
      </div>
      <!-- Bouton pour basculer l'affichage de la sidebar -->
      <button class="d-flex justify-content-start border-0 bg-transparent" id="sidebarToggle" type="button">
  <i class="fas fa-bars"></i>
</button>

      <ul class="navbar-nav ms-auto">
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" id="navbarDropdown" href="#" role="button" data-bs-toggle="dropdown">
            <i class="fas fa-user fa-fw"></i>
          </a>
          <ul class="dropdown-menu dropdown-menu-end">
            <li><a class="dropdown-item" href="#">Settings</a></li>
            <li><a class="dropdown-item" href="#">Activity Log</a></li>
            <li><hr class="dropdown-divider" /></li>
            <li>
              <button class="btn btn-danger w-100 fw-bold" @click="logout">
                Déconnexion
              </button>
              <!-- <router-link to="/mon_compte" class="nav-link">Mon compte</router-link> -->
            </li>
          </ul>
        </li>
      </ul>
    </nav>

    <!-- Layout principal -->
    <div id="layoutSidenav">
      <!-- Sidebar pour desktop (visible uniquement en version lg et plus) -->
      <div id="layoutSidenav_nav" class="d-none d-lg-block">
        <nav class="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
          <div class="sb-sidenav-menu">
            <div class="nav">
              <div class="sb-sidenav-menu-heading"></div>
              <router-link to="/tableauDeBord" class="nav-link">Tableau de bord</router-link>
              <router-link to="/home" class="nav-link">Faire une réservation</router-link>
              <router-link to="/add-location" class="nav-link">Liste des reservations</router-link>
              <router-link to="/inventairePage" class="nav-link">Inventaire</router-link>
              <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#pagesCollapseError" aria-expanded="false" aria-controls="pagesCollapseError">
                    Immobilisations
                    <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
                  </a>
                  <div class="collapse" id="pagesCollapseError" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordionPages">
                    <nav class="sb-sidenav-menu-nested nav">
                      <router-link to="/add-article" class="nav-link">Categories</router-link>
                      <router-link to="/modify-article" class="nav-link">Articles</router-link>
                    </nav>
                  </div>
              <!-- <div class="sb-sidenav-menu-heading">Interface</div> -->

              <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapseLayouts" aria-expanded="false" aria-controls="collapseLayouts">
                <div class="sb-nav-link-icon"><i class="fas fa-columns"></i></div>
                    Gestion d'accès
                <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
              </a>
                <div class="collapse" id="collapseLayouts" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
                <nav class="sb-sidenav-menu-nested nav">
                  <router-link to="/permission-page" class="nav-link">Rôles</router-link>
                      <router-link to="/mon_compte" class="nav-link">Mon compte</router-link>
                      <router-link to="/liste_utlisateur" class="nav-link">Listes des utilisateurs</router-link>
                </nav>
                </div>
              <!-- <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapsePages" aria-expanded="false" aria-controls="collapsePages">
                <div class="sb-nav-link-icon"><i class="fas fa-book-open"></i></div>
                Pages
                <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
              </a>
              <div class="collapse" id="collapsePages" aria-labelledby="headingTwo" data-bs-parent="#sidenavAccordion">
                <nav class="sb-sidenav-menu-nested nav accordion" id="sidenavAccordionPages">
                  <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#pagesCollapseAuth" aria-expanded="false" aria-controls="pagesCollapseAuth">
                    Authentification
                    <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
                  </a>
                  <div class="collapse" id="pagesCollapseAuth" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordionPages">
                    <nav class="sb-sidenav-menu-nested nav">
                      
                    </nav>
                  </div>
                </nav>
              </div> -->
              <!-- <div class="sb-sidenav-menu-heading">Addons</div> -->
              <!-- <router-link to="/permission-page" class="nav-link">Gestion d'accès</router-link> -->
            </div>
          </div>
          <div class="sb-sidenav-footer">
            <div class="small">Connecté en tant que : <strong>{{ userName }}</strong></div>

          </div>
        </nav>
      </div>

      <!-- Zone de contenu principale -->
      <div id="layoutSidenav_content">
        <slot></slot>
        <footer class="py-4 bg-light mt-auto">
          <div class="container-fluid px-4">
            <div class="d-flex align-items-center justify-content-between small">
              <div class="text-muted">Copyright &copy; mirindra 2025</div>
              <div>
                <a href="#">Privacy Policy</a>
                &middot;
                <a href="#">Terms &amp; Conditions</a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { Collapse } from "bootstrap";
import "@/assets/styles.css";

export default {
  name: "HeaderPage",
  data() {
    return {
      userName: "", // Stocke le nom de l'utilisateur
    };
  },
  mounted() {
    this.loadExternalScripts();
    this.initBootstrap();
    this.getUserInfo(); // Récupère le nom de l'utilisateur
  },
  methods: {
    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("userName"); // Supprime aussi le nom stocké
      this.$router.push("/login");
      alert("Vous avez été déconnecté avec succès.");
    },
    getUserInfo() {
      // Simule la récupération du nom depuis le localStorage ou une API
      this.userName = localStorage.getItem("userName") || "Utilisateur inconnu";
    },
    loadExternalScripts() {
      const scripts = [
        "https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/js/bootstrap.bundle.min.js",
        "https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.8.0/Chart.min.js",
        "https://cdn.jsdelivr.net/npm/simple-datatables@7.1.2/dist/umd/simple-datatables.min.js",
        "https://use.fontawesome.com/releases/v6.3.0/js/all.js",
        "js/scripts.js",
      ];
      scripts.forEach((src) => {
        const script = document.createElement("script");
        script.src = src;
        script.crossOrigin = "anonymous";
        script.async = true;
        document.body.appendChild(script);
      });
    },
    initBootstrap() {
      const elements = document.querySelectorAll(".collapse");
      elements.forEach((el) => new Collapse(el, { toggle: false }));
    },
  },
};
</script>

<style>
@import "https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css";
@import "https://cdn.jsdelivr.net/npm/simple-datatables@7.1.2/dist/style.min.css";

/* Styles personnalisés */
body {
  font-family: Arial, sans-serif;
}

/* Vous pouvez ajouter d'autres styles ici */
</style>
